module.exports = __webpack_public_path__ + "static/media/lending-tools6.c112cdcd.svg";